// Sample data for PDF preview
export const SAMPLE_DATA = {
  // Customer Information
  customerName: 'Hartley Building Supplies Ltd',
  customerContactName: 'James Hartley',
  customerEmail: 'accounts@hartleysupplies.co.uk',
  customerPhone: '01234 567890',
  customerAddressLine: '14 Commerce Way',
  customerAddressLine1: '14 Commerce Way',
  customerCity: 'Birmingham',
  customerCounty: 'West Midlands',
  customerPostcode: 'B12 4PQ',
  customerCountry: 'United Kingdom',
  accountNumber: 'HART001',
  paymentTerms: '30 days net',

  // Company Information
  companyName: 'Acme Corporation Ltd',
  companyEmail: 'credit@acmecorp.co.uk',
  companyPhone: '0121 456 7890',
  companyAddress: 'Acme House, 123 Business Park',
  companyCountry: 'United Kingdom',
  companyPostcode: 'EC1A 1BB',
  companyLogo: 'https://placehold.co/200x80/2563eb/white?text=ACME+Corporation',
  companyRegNumber: '12345678',
  companyVatNumber: 'GB123456789',
  companyBankName: 'Barclays Bank PLC',
  sortCode: '20-45-67',
  bankAccountNumber: '12345678',
  ibanNumber: 'GB29NWBK60161331926819',
  swiftBicCode: 'NWBKGB2L',

  // Document Details
  statementDate: new Date().toLocaleDateString('en-GB'),
  documentReference: 'STMT-2026-00142',
  currencyCode: 'GBP',

  // Financial Figures
  totalOutstanding: '£14,250.00',
  totalOverdue: '£8,750.00',
  currentBalance: '£5,500.00',
  creditLimit: '£20,000.00',
  availableCredit: '£5,750.00',
  lastPaymentAmount: '£3,000.00',
  lastPaymentDate: '15/01/2026',
  totalInvoiced: '£17,250.00',

  // Ageing Buckets
  ageingCurrent: '£5,500.00',
  ageing1To30: '£2,250.00',
  ageing31To60: '£3,500.00',
  ageing61To90: '£1,750.00',
  ageing91To120: '£1,250.00',
  ageing120Plus: '£2,000.00',
};

// Sample transaction table rows
export const SAMPLE_TRANSACTIONS = [
  {
    reference_number: 'INV-1042',
    transaction_date: '01/10/2025',
    due_date: '31/10/2025',
    transaction_description: 'Consultancy Services October',
    gross_amount: '£3,500.00',
    payments_received: '£0.00',
    outstanding_amount: '£3,500.00',
    days_overdue: '94',
    order_number: 'PO-2025-089',
    transaction_type: 'Invoice',
    currency: 'GBP',
    isOverdue: true,
  },
  {
    reference_number: 'INV-1058',
    transaction_date: '01/11/2025',
    due_date: '30/11/2025',
    transaction_description: 'Consultancy Services November',
    gross_amount: '£2,250.00',
    payments_received: '£0.00',
    outstanding_amount: '£2,250.00',
    days_overdue: '63',
    order_number: 'PO-2025-102',
    transaction_type: 'Invoice',
    currency: 'GBP',
    isOverdue: true,
  },
  {
    reference_number: 'INV-1071',
    transaction_date: '01/12/2025',
    due_date: '31/12/2025',
    transaction_description: 'Consultancy Services December',
    gross_amount: '£1,750.00',
    payments_received: '£0.00',
    outstanding_amount: '£1,750.00',
    days_overdue: '33',
    order_number: 'PO-2025-115',
    transaction_type: 'Invoice',
    currency: 'GBP',
    isOverdue: true,
  },
  {
    reference_number: 'INV-1089',
    transaction_date: '15/12/2025',
    due_date: '14/01/2026',
    transaction_description: 'Software Licence Q1',
    gross_amount: '£1,250.00',
    payments_received: '£0.00',
    outstanding_amount: '£1,250.00',
    days_overdue: '19',
    order_number: 'PO-2025-128',
    transaction_type: 'Invoice',
    currency: 'GBP',
    isOverdue: true,
  },
  {
    reference_number: 'INV-1094',
    transaction_date: '01/01/2026',
    due_date: '31/01/2026',
    transaction_description: 'Consultancy Services January',
    gross_amount: '£3,000.00',
    payments_received: '£3,000.00',
    outstanding_amount: '£0.00',
    days_overdue: '—',
    order_number: 'PO-2026-001',
    transaction_type: 'Invoice',
    currency: 'GBP',
    isOverdue: false,
  },
  {
    reference_number: 'INV-1102',
    transaction_date: '01/02/2026',
    due_date: '28/02/2026',
    transaction_description: 'Consultancy Services February',
    gross_amount: '£5,500.00',
    payments_received: '£0.00',
    outstanding_amount: '£5,500.00',
    days_overdue: '—',
    order_number: 'PO-2026-015',
    transaction_type: 'Invoice',
    currency: 'GBP',
    isOverdue: false,
  },
];

// Helper function to replace variables with sample data
export function replaceVariables(text: string, useSampleData: boolean): string {
  if (!text) return '';
  if (!useSampleData) {
    return text;
  }

  let result = text;
  Object.entries(SAMPLE_DATA).forEach(([key, value]) => {
    const regex = new RegExp(`<<${key}>>`, 'g');
    result = result.replace(regex, value);
  });
  return result;
}
